import { Injectable } from '@angular/core';
import { ToastService } from '../other/toaster.service';
import { Router } from '@angular/router';
import { SamhitaOndcWoCService } from './samhita-ondc-wo-c.service';
import { REDIRECTION_INFO, SESSION_STORAGE_KEYS } from '../../types/types';
import { SharedService } from '../other/shared.service';
import { AppLauncher } from '@capacitor/app-launcher';
import { Capacitor } from '@capacitor/core';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    private router: Router,
    private toastService: ToastService,private samhitaWoService : SamhitaOndcWoCService,private sharedService : SharedService) { }

  async createSession(response: { access_token: string }) {
    const { access_token } = response;
    if (!access_token) {
      this.toastService.presentToast('Failed to get the data!', 'danger');
      return;
    }
    this.getInSideApp({ access: access_token });
  }

  getInSideApp(tokens: { access: string }) {
    this.router.navigate([`auth/${tokens.access}`]);
  }

  loginWithSamhita(redirectionInfo:REDIRECTION_INFO | null = null) {
    this.samhitaWoService.getAuth2Url().subscribe(async (res: any) => {
      let url = res?.url;
      if (url) {
        const [baseUrl, queryString] = url.split('?');
        
        if (queryString) {
          const encodedParams = queryString
            .split('&')
            .map((param:any) => {
              const [key, value] = param.split('=');
              return `${key}=${encodeURIComponent(value)}`;
            })
            .join('&');
  
          url = `${baseUrl}?${encodedParams}`;
        }
  
        if(redirectionInfo?.PARAM_URL || redirectionInfo?.QUERY_PARAMS) this.sharedService.setDataToSessionStorage({key : SESSION_STORAGE_KEYS.REDIRECTION_DATA , data : redirectionInfo})
        
        // Use AppLauncher to open OAuth URL in default browser
        if (Capacitor.isNativePlatform()) {
          await AppLauncher.openUrl({ url });
        } else {
          window.location.href = url;
        }
      } else {
        this.toastService.presentToast('Failed to get the OAuth URL', 'danger');
      }
    });
  }
}
